export const AIIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.6665 5.9974L13.4998 4.16406L15.3332 3.33073L13.4998 2.4974L12.6665 0.664062L11.8332 2.4974L9.99984 3.33073L11.8332 4.16406L12.6665 5.9974ZM7.6665 6.33073L5.99984 2.66406L4.33317 6.33073L0.666504 7.9974L4.33317 9.66406L5.99984 13.3307L7.6665 9.66406L11.3332 7.9974L7.6665 6.33073ZM12.6665 9.9974L11.8332 11.8307L9.99984 12.6641L11.8332 13.4974L12.6665 15.3307L13.4998 13.4974L15.3332 12.6641L13.4998 11.8307L12.6665 9.9974Z" />
  </svg>
);
